import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type ChatMessageSendingJobIndexPageQueryVariables = Types.Exact<{
  jobsAfter?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ChatMessageSendingJobIndexPageQuery = { __typename?: 'Query', chatMessageSendingJobs: { __typename?: 'ChatMessageSendingJobConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'ChatMessageSendingJobEdge', cursor: string, node: { __typename?: 'ChatMessageSendingJob', guid: string, target: string, sentAt?: TimeString | null, scheduledAt?: TimeString | null, status: Types.ChatMessageSendingJobStatus, messages: Array<{ __typename: 'ChatMessageSendingJobMessageImage', guid: string, imageUri: string, linkUri: string, altText: string } | { __typename: 'ChatMessageSendingJobMessageQuestion', guid: string, body: string, selections: Array<string> } | { __typename: 'ChatMessageSendingJobMessageText', guid: string, text: string }> } }> } };

export type ChatMessageSendingJobIndexPagePageInfoFragment = { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null };

export type ChatMessageSendingJobIndexPageEdgeFragment = { __typename?: 'ChatMessageSendingJobEdge', cursor: string, node: { __typename?: 'ChatMessageSendingJob', guid: string, target: string, sentAt?: TimeString | null, scheduledAt?: TimeString | null, status: Types.ChatMessageSendingJobStatus, messages: Array<{ __typename: 'ChatMessageSendingJobMessageImage', guid: string, imageUri: string, linkUri: string, altText: string } | { __typename: 'ChatMessageSendingJobMessageQuestion', guid: string, body: string, selections: Array<string> } | { __typename: 'ChatMessageSendingJobMessageText', guid: string, text: string }> } };

export type ChatMessageSendingJobIndexPageJobFragment = { __typename?: 'ChatMessageSendingJob', guid: string, target: string, sentAt?: TimeString | null, scheduledAt?: TimeString | null, status: Types.ChatMessageSendingJobStatus, messages: Array<{ __typename: 'ChatMessageSendingJobMessageImage', guid: string, imageUri: string, linkUri: string, altText: string } | { __typename: 'ChatMessageSendingJobMessageQuestion', guid: string, body: string, selections: Array<string> } | { __typename: 'ChatMessageSendingJobMessageText', guid: string, text: string }> };

export type ChatMessageSendingJobIndexPageJobMessage_ChatMessageSendingJobMessageImage_Fragment = { __typename: 'ChatMessageSendingJobMessageImage', guid: string, imageUri: string, linkUri: string, altText: string };

export type ChatMessageSendingJobIndexPageJobMessage_ChatMessageSendingJobMessageQuestion_Fragment = { __typename: 'ChatMessageSendingJobMessageQuestion', guid: string, body: string, selections: Array<string> };

export type ChatMessageSendingJobIndexPageJobMessage_ChatMessageSendingJobMessageText_Fragment = { __typename: 'ChatMessageSendingJobMessageText', guid: string, text: string };

export type ChatMessageSendingJobIndexPageJobMessageFragment = ChatMessageSendingJobIndexPageJobMessage_ChatMessageSendingJobMessageImage_Fragment | ChatMessageSendingJobIndexPageJobMessage_ChatMessageSendingJobMessageQuestion_Fragment | ChatMessageSendingJobIndexPageJobMessage_ChatMessageSendingJobMessageText_Fragment;

export const ChatMessageSendingJobIndexPagePageInfoFragmentDoc = gql`
    fragment ChatMessageSendingJobIndexPagePageInfo on PageInfo {
  hasNextPage
  endCursor
}
    `;
export const ChatMessageSendingJobIndexPageJobMessageFragmentDoc = gql`
    fragment ChatMessageSendingJobIndexPageJobMessage on ChatMessageSendingJobMessage {
  __typename
  ... on ChatMessageSendingJobMessageText {
    guid
    text
  }
  ... on ChatMessageSendingJobMessageImage {
    guid
    imageUri
    linkUri
    altText
  }
  ... on ChatMessageSendingJobMessageQuestion {
    guid
    body
    selections
  }
}
    `;
export const ChatMessageSendingJobIndexPageJobFragmentDoc = gql`
    fragment ChatMessageSendingJobIndexPageJob on ChatMessageSendingJob {
  guid
  target
  messages {
    ...ChatMessageSendingJobIndexPageJobMessage
  }
  sentAt
  scheduledAt
  status
}
    ${ChatMessageSendingJobIndexPageJobMessageFragmentDoc}`;
export const ChatMessageSendingJobIndexPageEdgeFragmentDoc = gql`
    fragment ChatMessageSendingJobIndexPageEdge on ChatMessageSendingJobEdge {
  cursor
  node {
    ...ChatMessageSendingJobIndexPageJob
  }
}
    ${ChatMessageSendingJobIndexPageJobFragmentDoc}`;
export const ChatMessageSendingJobIndexPageDocument = gql`
    query ChatMessageSendingJobIndexPage($jobsAfter: String) {
  chatMessageSendingJobs(first: 25, after: $jobsAfter) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      ...ChatMessageSendingJobIndexPageEdge
    }
  }
}
    ${ChatMessageSendingJobIndexPageEdgeFragmentDoc}`;

/**
 * __useChatMessageSendingJobIndexPageQuery__
 *
 * To run a query within a Vue component, call `useChatMessageSendingJobIndexPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatMessageSendingJobIndexPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChatMessageSendingJobIndexPageQuery({
 *   jobsAfter: // value for 'jobsAfter'
 * });
 */
export function useChatMessageSendingJobIndexPageQuery(variables: ChatMessageSendingJobIndexPageQueryVariables | VueCompositionApi.Ref<ChatMessageSendingJobIndexPageQueryVariables> | ReactiveFunction<ChatMessageSendingJobIndexPageQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ChatMessageSendingJobIndexPageQuery, ChatMessageSendingJobIndexPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ChatMessageSendingJobIndexPageQuery, ChatMessageSendingJobIndexPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ChatMessageSendingJobIndexPageQuery, ChatMessageSendingJobIndexPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ChatMessageSendingJobIndexPageQuery, ChatMessageSendingJobIndexPageQueryVariables>(ChatMessageSendingJobIndexPageDocument, variables, options);
}
export function useChatMessageSendingJobIndexPageLazyQuery(variables: ChatMessageSendingJobIndexPageQueryVariables | VueCompositionApi.Ref<ChatMessageSendingJobIndexPageQueryVariables> | ReactiveFunction<ChatMessageSendingJobIndexPageQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ChatMessageSendingJobIndexPageQuery, ChatMessageSendingJobIndexPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ChatMessageSendingJobIndexPageQuery, ChatMessageSendingJobIndexPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ChatMessageSendingJobIndexPageQuery, ChatMessageSendingJobIndexPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ChatMessageSendingJobIndexPageQuery, ChatMessageSendingJobIndexPageQueryVariables>(ChatMessageSendingJobIndexPageDocument, variables, options);
}
export type ChatMessageSendingJobIndexPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ChatMessageSendingJobIndexPageQuery, ChatMessageSendingJobIndexPageQueryVariables>;